import { Link } from "@quintype/components";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import User from "../../../../atoms/other-icons/User";
import "./custom-signin.m.css";

function CustomSignin({ signinHandler, color }) {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  return (
    <div styleName="wrapper" onClick={signinHandler}>
      {isMobile ? (
        <Link styleName="signin-btn-only-icon" className="signin-btn-only-icon" targer="_blank">
          <User color={color} width="10.31px" height="11.61px" />
        </Link>
      ) : (
        <Link style={{ color: color }} styleName="signin-btn" className="signin-btn" targer="_blank">
          <User color={color} width="10.31px" height="11.61px" />
          Sign in
        </Link>
      )}
    </div>
  );
}

export default CustomSignin;
